// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.jsoneditor-poweredBy{display:none}#json-editor{height:500px;min-height:500px}", ""]);
// Exports
module.exports = exports;
